import { get } from "lodash";
import curryConnector from "utils/connectors";

export const PATIENT_OCR_STATE_KEY = "patientOCR";

const curry = fn => curryConnector(fn, PATIENT_OCR_STATE_KEY);

export const ActionTypes = {
  SET_CURRENT_ATTACHMENT: "SET_CURRENT_ATTACHMENT",
  RESET_CURRENT_ATTACHMENT: "RESET_CURRENT_ATTACHMENT",
  SET_CURRENT_REPORT: "SET_CURRENT_REPORT",
  RESET_CURRENT_REPORT: "RESET_CURRENT_REPORT",
};

const defaultAttachment = {
  fileName: "",
};

const defaultReport = {
  printableViewContent: "",
  printableViewType: "",
  printableViewEncoding: "",
  documentVersion: "",
  type: "",
  isLatestVersion: undefined,
};

const INITIAL_STATE = {
  currentFile: defaultAttachment,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.SET_CURRENT_ATTACHMENT:
      return {
        ...state,
        currentFile: action.payload,
      };
    case ActionTypes.RESET_CURRENT_ATTACHMENT:
      return {
        ...state,
        currentFile: defaultAttachment,
      };
    case ActionTypes.SET_CURRENT_REPORT:
      return {
        ...state,
        currentReport: action.payload,
      };
    case ActionTypes.RESET_CURRENT_REPORT:
      return {
        ...state,
        currentReport: defaultReport,
      };
    default:
      return state;
  }
};

export const getCurrentAttachment = curry(({ localState }) => get(localState, ["currentFile"], null));

export const getCurrentReport = curry(({ localState }) => get(localState, ["currentReport"], null));

